module.exports = __webpack_public_path__ + "static/media/rubik-v14-latin-500.4e93c2bf.woff";